{
    "Auth0": {
        "Domain": "auth.demo.liquiditycube.net",
        "ClientId": "va754jBo2uOXrJW5fA2vpuOlXh6nccEk",
        "Audience": "https://demo.liquiditycube.net/api",
        "Namespace": "https://liquiditycube.net"
    },
    "BaseUrl": "https://api.demo.liquiditycube.net",
    "BannerUrl": "DEMO",
    "MegaPipe": {
        "BaseUrl": "https://megapipe.demo.liquiditycube.net"
    }
}